export default {
  required: "{attribute} は必須です",
  equqls: "{attribute} は値が不正です",
  alphaNum: "{attribute} は「英字」「数字」のみ有効です",
  fileSizeMb: "{attribute} は {max} MB以下のみ有効です",
  fileSizeExt: "{attribute} は 拡張子が無効です",
  character: {
    environmentDependent: "{attribute} に機種依存文字を含めることできません",
  },
  email: {
    format: "{attribute} は書式が無効です",
  },
  password: {
    format: "{attribute} は半角英数記号のみ有効です",
    same: "同じ{attribute} を入力してください",
    lowercase: "{attribute} は小文字英字を１つ以上含む必要があります",
    uppercase: "{attribute} は大文字英字を１つ以上含む必要があります",
    number: "{attribute} は数字を１つ以上含む必要があります",
  },
  phoneNumber: {
    format: "{attribute} は書式が無効です",
  },
  authCode: "{attribute} の入力に誤りがあります",
  productKey: "{attribute} の入力に誤りがあります",
  max: {
    string: "{attribute} は {max} 文字以下のみ有効です",
  },
  min: {
    string: "{attribute}  は {min} 文字以上のみ有効です",
  },
};
